import { useState, useEffect } from 'react';
import FJUtil from '../../../util/FJUtil';

export default function useIsMobile() {
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        if (FJUtil.isMobile()) {
            setIsMobile(true);
        }
    }, []);

    return { isMobile };
}
